import DashboardLayout from "@/layouts/DashboardLayout.vue";
import ContenidoNosotrosView from "../views/ContenidoNosotrosView.vue";

const routes = [
  {
    path: "/contenido",
    component: DashboardLayout,
    children: [
      {
        path: "nosotros",
        name: "ContenidoNosotros",
        component: ContenidoNosotrosView,
        meta: {
          permissions: "baret_navbar:dashboard",
        },
      },
      {
        path: "sitio",
        name: "ContenidoSitio",
        component: () => import("../views/ContenidoSitioView.vue"),
        meta: {
          permissions: "baret_navbar:dashboard",
        },
      },
    ],
  },
];

export default routes;
